import { HttpErrorResponse, HttpEvent, HttpEventType, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@environment/environment';
import { HttpDevToolsService } from '@app/services/dev-tools/http-dev-tools.service';
import { catchError, tap, throwError } from 'rxjs';

export const httpDevToolsInterceptor: HttpInterceptorFn = (req, next) => {
  if (!environment.httpDevToolsEnabled) {
    return next(req);
  }

  const devTools = inject(HttpDevToolsService);
  const id = createRequestId();

  devTools.start({
    id,
    method: req.method,
    url: req.url,
    urlWithParams: req.urlWithParams,
    request: {
      headers: devTools.headersToRecord(req.headers),
      params: devTools.paramsToRecord(req.params),
      body: devTools.sanitizeValue(req.body),
    },
  });

  return next(req).pipe(
    tap((event: HttpEvent<unknown>) => {
      if (event.type === HttpEventType.Response && event instanceof HttpResponse) {
        devTools.complete(id, event);
      }
    }),
    catchError((error: HttpErrorResponse) => {
      devTools.fail(id, error);
      return throwError(() => error);
    })
  );
};

function createRequestId(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
